import React, { useState } from 'react';
import DistributorRepSetup, { IndependentPortalLogin } from './DistributorRepSetup';
import DistributorPreviewSetup from './DistributorPreviewSetup';

/** Account setup stays together; the server independently restricts administrator provisioning. */
export default function DistributorLoginSetup({ distributor, workspaceAdmin, admin }) {
  const [open, setOpen] = useState(false);
  return (
    <>
      {distributor && (!workspaceAdmin || distributor.independentCustomers) && (
        <DistributorRepSetup key={distributor._id} distributor={distributor} admin={admin} />
      )}
      {distributor?.isActive === true &&
        (distributor.independentCustomers || distributor.sourceClientUser) && (
          <DistributorPreviewSetup
            key={`preview-${distributor._id}`}
            distributor={distributor}
            admin={admin}
          />
        )}
      {!workspaceAdmin && (
        <section
          className="me-distributor-admin-card space-y-4"
          aria-label="Workspace administrators"
        >
          <button
            type="button"
            className="me-distributor-admin-secondary"
            disabled={admin.busy}
            onClick={() => setOpen((value) => !value)}
            aria-expanded={open}
          >
            {open ? 'Close administrator setup' : 'Add distributor administrator'}
          </button>
          {open && <IndependentPortalLogin workspaceAdmin admin={admin} />}
        </section>
      )}
    </>
  );
}
